import { useNavigate } from 'react-router-dom';

import { updatePractice } from 'api/Practice';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

// `display_settings` is replaced wholesale by the backend, so callers pass the full object.
export const useUpdatePracticeBranding = ({ onSuccess } = {}) => {
  const navigate = useNavigate();

  return useCustomMutation({
    mutationFn: ({ practiceId, displaySettings }) =>
      updatePractice(navigate, {
        practice_id: practiceId,
        fields: { display_settings: displaySettings }
      }),
    successMessage: 'Brand colors saved',
    errorMessage: "Couldn't save brand colors",
    invalidateQueryKey: [['currentPractice']],
    onSuccess
  });
};
